export default {
  path: '/videoFactory',
  name: 'videoFactory',
  meta: { title: '视频梦工厂' },
  children: [
    {
      path: '/videoFactory/index',
      name: 'videoFactoryIndex',
      component: () => import('@/views/videoFactory/index.vue'),
      meta: { title: '视频梦工厂', subTitle: 'AI 驱动的智能视频创作平台', key: 'videoFactory' },
    },
  ],
};
